module.exports = __webpack_public_path__ + "media/assets/avia/sidebar/terminal-56f105134770cd6032c211e462b80d50.png";